// ----------------------------------------------------------------------------
// Объекты с закэшированными DOM-элементами
// Централизуют доступ к элементам, чтобы не искать их по всему DOM при каждом вызове функций.
// Эти элементы изначально есть в разметке, скрипт их не подгружает
// ----------------------------------------------------------------------------

/**
 * Объект с закэшированными DOM-элементами, которые есть и на сплеш-странице и в ЛК (ОБЩЕЕ).
 *
 * @type {Object}
 * @property {HTMLInputElement|null} ttAuthPasswordOld - поле старого пароля
 * @property {HTMLInputElement|null} ttAuthPasswordNew - поле нового пароля еще раз
 * @property {HTMLInputElement|null} ttAuthPassword - поле нового пароля
 */

export const authAccountElements = {
    ttAuthPasswordOld: document.getElementById('ttAuth_password_old'),
    ttAuthPasswordNew: document.getElementById('ttAuth_password_new'),
    ttAuthPassword: document.getElementById('ttAuth_password'),
}


/**
 * Объект с закэшированными DOM-элементами ИНТЕРФЕЙСА АВТОРИЗАЦИИ И РЕГИСТРАЦИИ.
 *
 * @type {Object}
 * @property {HTMLElement|null} authRegistration - обертка блока регистрастрации или входа
 * @property {HTMLFormElement|null} ttAuthForm - форма на странице входа или в ЛК
 * @property {HTMLButtonElement|null} ttAuthBtn - кнопка "войти на сайт"
 * @property {HTMLInputElement|null} ttAuthHiddenField - скрытое поле (хранит флаг регистрации или авторизации например)
 * @property {HTMLDivElement|null} ttAuthAvaDiv - обертка для аватара при регистрации на сплеш-странице
 * @property {HTMLElement|null} ttAuthAva - input=file для загрузки аватара
 * @property {HTMLDivElement|null} ttAuthCapDiv - обертка для капчи на сплеш-странице
 * @property {HTMLInputElement|null} ttAuthEmail - поле ввода емейла
 * @property {HTMLInputElement|null} ttAuthName - поле "имя на сайте"
 //* @property {HTMLElement|null} ttAuthNameTxt - [ОПИСАНИЕ]
 //* @property {HTMLElement|null} ttAuthNameDiv - [ОПИСАНИЕ]
 * @property {HTMLDivElement|null} ttAuthNameTxtDiv - содержит текстовую подпись "Имя или ник"
 * @property {NodeList} headerTTUsers - контейнеры для вывода ника и выхода из аккаунта в шапке сайта (две медии)
 * @property {NodeList} headerTTAuthRegistrations - контейнеры, содержащие кнопки входа (две медии)
 * @property {NodeList} headerTTUserNames - контейнеры, содержащие имя пользователя  (две медии)
 * @property {HTMLAnchorElement|null} ttAuthTabRegistration - таб "зарегистрироваться"
 * @property {HTMLAnchorElement|null} ttAuthTabEnter - таб "войти"
 * @property {HTMLAnchorElement|null} FLRemindme - ссылка "вспомнить пароль"
 * @property {HTMLDivElement|null} digest - обертка блока подписки на дайджест
 */

export const authElements = {
    authRegistration: document.querySelector('.auth-registration'),
    ttAuthForm: document.getElementById('ttAuth_form'),
    ttAuthBtn: document.getElementById('ttAuth_btn'),
    ttAuthHiddenField: document.getElementById('ttAuth_t'),
    ttAuthAvaDiv: document.getElementById('ttAuth_ava_div'),
    ttAuthAva: document.getElementById('ttAuth_ava'),
    ttAuthCapDiv: document.getElementById('ttAuth_cap_div'),
    ttAuthEmail: document.getElementById('ttAuth_email'),
    ttAuthName: document.getElementById('ttAuth_name'),
    //ttAuthNameTxt: document.getElementById('ttAuth_name_txt'), есть в разметке, но в коде только очищается
    //ttAuthNameDiv: document.getElementById('ttAuth_name_div'), вообще кажется нет
    ttAuthNameTxtDiv: document.getElementById('ttAuth_name_txt_div'),
    headerTTUsers: document.querySelectorAll('.header_tt_user'),
    headerTTAuthRegistrations: document.querySelectorAll('.header_tt_auth_registration'),
    headerTTUserNames: document.querySelectorAll('.header_tt_user_name'),
    ttAuthTabRegistration: document.getElementById('ttAuth_tab_registration'),
    ttAuthTabEnter: document.getElementById('ttAuth_tab_enter'),
    FLRemindme: document.querySelector('.footer-link--remindme'),
    digest: document.querySelector('.auth-registration__digest')
}


/**
 * Объект с закэшированными DOM-элементами ИНТЕРФЕЙСА ЛИЧНОГО КАБИНЕТА.
 *
 * @type {Object}
 * @property {HTMLHeadingElement|null} accountHeader - заголовок H1 ЛК (к нему цепляем сообщения)
 * @property {HTMLDivElement|null} avatar - обертка картинки аватара
 * @property {NodeList|null} changePasswordFields - контейнеры полей для смены пароля
 * @property {HTMLDivElement|null} changePassword - контейнер кнопки "сменить пароль"
 * @property {HTMLAnchorElement|null} accountDel - ссылка "удалить профиль"
 */

export const accountElements = {
    accountHeader: document.querySelector('.js-myaccount__header'),
    avatar: document.getElementById('js-myaccount-avatar'),
    changePasswordFields: document.querySelectorAll('.change_password_fields'),
    changePassword: document.querySelector('.change_password'),
    accountDel: document.getElementById('js-myaccount-del'),
}


/**
 * Объект с закэшированными DOM-элементами для авторизации в отзывах.
 *
 * @type {Object}
 * @property {HTMLInputElement|null} formAuthMail - поле ввода емейла при добавлении отзыва (авторизация в отзывах)
 * @property {HTMLInputElement|null} formAuthPass - поле ввода пароля при добавлении отзыва (авторизация в отзывах)
 * @property {NodeList} respondFormPasses - спан (содержит название Пароль) + интпут для этого пароля (ex.
 * @property {HTMLAnchorElement} rememberFormPassword - ссылка вспомнить пароль
 * @property {HTMLParagraphElement} respondFormCodes - здесь выводится сообщение об отправке пароля на почту
 * @property {HTMLButtonElement|null} buttonNext - кнопка продолжить авторизацию
 * @property {HTMLDivElement|null} authForm - обертка формы авторизации в отзывах
 * @property {NodeList} authFormHiddens - скрытые блоки формы авторизации (контейнер предупреждения и кнопки)
 * @property {HTMLInputElement|null} nickInput - скрытое поле, хранит судя по всему $TT_USER_NAME
 */

export const reviewsAuthElements = {
    formAuthMail: document.getElementById('js-respond-form_auth_mail'),
    formAuthPass: document.getElementById('js-respond-form_auth_pass'),
    respondFormPasses: document.querySelectorAll('.js-respond-form_pass'),
    rememberFormPassword: document.querySelector('.js-respond-remember_pass'),
    respondFormCode: document.querySelector('.js-respond-form_code'),
    buttonNext: document.getElementById('js-respond-form__btn-next'),
    authForm: document.getElementById('ttOtzyv_authForm'),
    authFormHiddens: document.querySelectorAll('.ttOtzyv_authFormHidden'),
    nickInput: document.getElementById('ttOtzyvComment_nick'),
}
